export default "__VITE_ASSET__BmVxbiBS__"